import React from 'react';
import { PhoneInput } from '@makemydeal/dr-shared-components/phone-input';
import { validateLendersListPhone } from '@makemydeal/dr-shared-ui-utils/utils/lenderValidationUtils';

import { LENDER_PHONE } from '../../constants';
import LenderAddressTextField from './LenderAddressTextField.interstate';

const LENDER_PHONE_ERROR = 'Enter a valid phone number.';

// PhoneInput ships its own built-in validation (isPhoneNumberValid) that renders inline
// independently of our validation engine, so the inline error and the lender red dot were driven
// by two different rules. Route PhoneInput's inline validation through our shared rule via
// `getError` so both the inline message and the red dot derive from the same complete-phone rule.
// Empty is allowed (field is optional).
export const validateLenderPhone = (_label: string | undefined, value: string | undefined) => {
    const isValid = !value || validateLendersListPhone(value);
    return isValid
        ? { triggered: false, validationState: { type: undefined, isValid: true } }
        : { triggered: true, validationState: { type: 'error' as const, isValid: false, message: LENDER_PHONE_ERROR } };
};

const LenderPhoneField = () => (
    <LenderAddressTextField
        id="LenderPhoneField"
        dataTestId="lender-phone"
        label={LENDER_PHONE}
        name="lender-phone"
        field="phone"
        InputComponent={PhoneInput}
        extraInputProps={{ getError: validateLenderPhone }}
    />
);

export default LenderPhoneField;
